import { useMutation } from 'react-query'
import postRegisterEconomic from '../services/postRegisterEconomic'

function usePostRegisterEconomic() {

  return useMutation((value:object)=>postRegisterEconomic(value) );
}

export default usePostRegisterEconomic
